import { Box, Button, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { NoSchools } from '../../assets/images';

export type NotFoundContentProps = {
  message?: string;
  actionLabel?: string;
  goBack?: () => void;
};

export const NotFoundContent: FC<NotFoundContentProps> = ({
  actionLabel,
  goBack,
  message: propsMessage,
}) => {
  const { formatMessage } = useIntl();
  const message = propsMessage ?? formatMessage({ id: 'notfound-message' });
  return (
    <Stack flex={1} alignItems="center" justifyContent="center">
      <Box mb={4}>
        <picture>
          <img src={NoSchools} alt={message} />
        </picture>
      </Box>
      <Typography variant="h2" mb={6}>
        {message}
      </Typography>

      {goBack && (
        <Button onClick={goBack}>{actionLabel ?? formatMessage({ id: 'action-Back' })}</Button>
      )}
    </Stack>
  );
};
